export default __webpack_public_path__ + "static/media/WeD3.8138b7f0.png";